import { useQuery } from 'react-query';
import axiosInstance from './axiosInstance';
import { useAuthContext } from '../contexts/AuthContext';

const useFetch = (endpoint, id, data, interval, baseUrl) => {
    const {checkToken} = useAuthContext();

    const fetchData = async () => {
        try {
            await checkToken();
            const response = await axiosInstance('GET', endpoint, data, 'application/json', baseUrl);
            return response.data;
        } catch (err) {
            console.log("Erro na api" + endpoint + "ao buscar dados:", err);
            return null;
        };
    };

    return useQuery([id], () => fetchData(), {
        refetchOnWindowFocus: false,
        refetchInterval: interval,
        retry: false,
    });
};

export default useFetch;